module.exports = "<p>\n  chart-example works!\n</p>\n\n<div>\n  <nvd3 [options]=\"options\" [data]=\"data\"></nvd3>\n</div>\n"